<section class="modal-body">
	<div class="modal-header">
		<div>
			<h3 class="fw-bold fs-xs">Revisão de titularidade</h3>
			<p class="fs-xxs gray">
				{{ transitionTitle }}. A aplicação altera somente o beneficiário
				analisado.
			</p>
		</div>
		<button mat-icon-button type="button" (click)="onClose()">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<div class="modal-content">
		<div class="summary-banner" [class.ready]="isReadyToApply">
			<div>
				<span class="label">Beneficiário analisado</span>
				<strong>{{ subjectBeneficiaryName | titlecase }}</strong>
				<div class="summary-meta">
					<span>CPF {{ subjectBeneficiaryCpf }}</span>
					<span>{{ itemOrganization }}</span>
					<span>{{ itemCarrier }}</span>
				</div>
			</div>
			<span class="review-badge" [class.ready]="isReadyToApply">
				{{ reviewStatusLabel }}
			</span>
		</div>

		<section class="relationship-change">
			<div class="relationship-card">
				<span class="label">Hoje na plataforma</span>
				<strong>{{ systemTypeLabel }}</strong>
				<div class="holder-details" *ngIf="shouldShowSystemHolderDetails">
					<span>CPF do titular atual</span>
					<strong>{{ systemHolderCpfLabel }}</strong>
				</div>
			</div>
			<mat-icon>east</mat-icon>
			<div class="relationship-card relationship-card--target">
				<span class="label">Base do cliente</span>
				<strong>{{ planTypeLabel }}</strong>
				<div class="holder-details" *ngIf="shouldShowPlanHolderDetails">
					<span>CPF do titular</span>
					<strong>{{ planHolderCpfLabel }}</strong>
				</div>
			</div>
		</section>

		<section class="resolution-choice-section">
			<button
				type="button"
				class="resolution-choice-option"
				[class.active]="selectedAction === 'UPDATE_TITULARITY'"
				(click)="onSelectAction('UPDATE_TITULARITY')"
			>
				<input
					type="radio"
					[checked]="selectedAction === 'UPDATE_TITULARITY'"
					(change)="onSelectAction('UPDATE_TITULARITY')"
				/>
				<div class="resolution-choice-option__content">
					<span class="label">Base do cliente</span>
					<strong>Usar titularidade da base do cliente</strong>
					<span>{{ transitionTitle }}</span>
				</div>
			</button>

			<button
				type="button"
				class="resolution-choice-option"
				[class.active]="selectedAction === 'IGNORE_ITEM'"
				(click)="onSelectAction('IGNORE_ITEM')"
			>
				<input
					type="radio"
					[checked]="selectedAction === 'IGNORE_ITEM'"
					(change)="onSelectAction('IGNORE_ITEM')"
				/>
				<div class="resolution-choice-option__content">
					<span class="label">Plataforma</span>
					<strong>Manter valor da plataforma</strong>
					<span>Mantém a titularidade atual sem aplicar alteração.</span>
				</div>
			</button>
		</section>

		<section
			class="review-section"
			*ngIf="selectedAction === 'UPDATE_TITULARITY' && !canResolveWithHolderCpf"
		>
			<div>
				<h3 class="fs-xxs fw-bold">Pendência para resolver</h3>
				<p class="fs-xxs gray">{{ reviewReasonText }}</p>
			</div>
			<p class="resolution-note fs-xxs" *ngIf="shouldShowResolutionSummary">
				{{ transitionDescription }}
			</p>
		</section>

		<section
			class="correction-section"
			*ngIf="selectedAction === 'UPDATE_TITULARITY' && canResolveWithHolderCpf"
		>
			<div>
				<h3 class="fs-xxs fw-bold">Pendência para resolver</h3>
				<p class="fs-xxs gray">
					Informe um CPF de titular válido e ativo que exista na plataforma.
					{{ transitionDescription }}
				</p>
			</div>
			<mat-form-field appearance="outline" class="holder-cpf-field">
				<mat-label>CPF do titular válido</mat-label>
				<input
					matInput
					[formControl]="validHolderCpfControl"
					inputmode="numeric"
					maxlength="14"
					placeholder="000.000.000-00"
				/>
				<mat-error *ngIf="validHolderCpfControl.hasError('required')">
					Informe o CPF do titular.
				</mat-error>
				<mat-error *ngIf="validHolderCpfControl.hasError('pattern')">
					Informe um CPF com 11 dígitos.
				</mat-error>
			</mat-form-field>
			<button
				mat-flat-button
				color="primary"
				type="button"
				(click)="onSaveHolderCpf()"
			>
				Adicionar à fila
			</button>
		</section>
	</div>

	<div class="modal-actions">
		<div class="dialog-actions__secondary">
			<button
				mat-stroked-button
				color="primary"
				type="button"
				(click)="onPlaceOnHold()"
			>
				Colocar em espera
			</button>
			<button
				mat-stroked-button
				color="primary"
				type="button"
				[disabled]="!canApplyOnlyResolution"
				(click)="onApplyOnly()"
			>
				Aplicar somente este
			</button>
		</div>
		<div class="dialog-actions__primary">
			<button
				mat-flat-button
				color="primary"
				type="button"
				[disabled]="!canSaveResolution"
				(click)="onConfirmSuggested()"
			>
				Salvar na fila
			</button>
			<button
				mat-button
				color="warn"
				type="button"
				[disabled]="!hasPendingChange"
				(click)="onRemove()"
			>
				Remover da fila
			</button>
		</div>
	</div>
</section>
